/**
 * @flow
 * @format
 */

import React from 'react';
import { defaultProps } from 'recompose';
import cc from 'classcat';
import CubeGrid from 'better-react-spinkit/dist/CubeGrid/index';

import classes from './Loading.scss';

type PropsType = {
  col: number,
  color: string,
  loaderStyle: CSSRules,
  row: number,
  size: number,
  text: string,
  textStyle: CSSRules,
};

export const Loading = (props: PropsType) => (
  <div className={cc([classes.wrapper, 'p-5'])}>
    <CubeGrid
      col={props.col}
      color={props.color}
      row={props.row}
      size={props.size}
      style={props.loaderStyle}
    />
    <h3 style={props.textStyle}>{props.text}</h3>
  </div>
);

const withDefaults = defaultProps({
  col: 3,
  row: 3,
  size: 72,
  color: '',
  loaderStyle: {},
  text: 'Loading Data',
  textStyle: {
    paddingTop: '1.5rem',
    paddingBottom: '0',
  },
});

export default withDefaults(Loading);



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js